import React, { Component } from "react";
import { useNavigate, Link } from "react-router-dom";

function Footer() {
  return (
    <footer id="footer" className="footer">
      <p className="copyright">
        COPYRIGHT (C) 2024 하이텍정보. All Rights Reserved.
      </p>
    </footer>
  );
}

export default Footer;
